class SignupRegister {
  constructor($env, $auth, $timeout, $rootScope, $tracking, tracking, SignUpFormatting, $http) {
    this.$env = $env;
    this.$auth = $auth;
    this.$timeout = $timeout;
    this.$rootScope = $rootScope;
    this.$tracking = $tracking;
    this.tracking = tracking;
    this.format = SignUpFormatting;
    this.$http = $http;
  }

  constructReq(user, marketingParamsSubgStr) {
    const {phone_number, company_name, first_name, last_name, email, password, check_policy, userInvitedToken} = user || {};

    // API Request Body
    console.log("constructReq");
    console.dir(user);

    const req = {
      method: "POST",
      url: this.$env.getAPIEndPoint() + "register/register?format=json&conf=web" + marketingParamsSubgStr,
      data: {
        company: {
          defaultPlan: 31,
          mainContactInfo: {
            phoneMobile: phone_number,
          },
          name: company_name,
          //"partner" : "DelivLog"
        },
        // firstName: first_name,
        // lastName: last_name,
        username: email,
        password: password,
        termsOfService: check_policy,
        acceptedWebAgreement: true,
        acceptedPrivacyAgreement: true,
        acceptedCookieAgreement: true,
        token: userInvitedToken ? userInvitedToken : "",
      },
    };

    return req;
  }

  formatUserObject(vm) {
    let {phone_number, company_name, first_name, last_name, email, password, check_policy, userInvitedToken} = vm || {};

    phone_number = this.format.parsePhone(phone_number);

    return {
      phone_number,
      company_name,
      first_name,
      last_name,
      email,
      password,
      check_policy,
      userInvitedToken,
    };
  }

  formatJobblerObject(vm) {
    let {first_name, last_name, zip_code, email, password, check_policy} = vm || {};

    zip_code = zip_code ? zip_code.replace(/\D/g, "") : zip_code;

    return {
      first_name,
      last_name,
      zip_code,
      email,
      password,
      check_policy,
    };
  }

  loginUser(user) {
    return new Promise((resolve) => {
      this.$auth.lazyLoginExists(user).then(
        (data) => {
          const currentUser = data.data;
          const loginStatus = parseInt(data.status);

          if (loginStatus === 200) {
            this.$timeout(() => {
              this.$rootScope.$emit("UpdateCurrentUser", {
                user: currentUser,
              });
              this.$tracking.reportUserRegistration(currentUser);

              resolve({success: true, user: currentUser});
            }, 500);
          } else {
            const errorMessage = data.statusText;
            resolve({success: false, error: errorMessage});
          }
        },
        (data) => {
          const errorMessage = data;
          resolve({success: false, error: errorMessage});
        }
      );
    });
  }

  companySignup(user) {
    try {
      this.$auth.registerCompanyInHubspot(user);
    } catch (e) {
      console.error("Hubspot registration error:", e);
    }

    const marketingParamsSubgStr = this.tracking.makeMarketingString();

    const req = this.constructReq(user, marketingParamsSubgStr);

    let registerStatus = "";
    let errorMessage = "";
    let success = true;

    console.log("what is req");
    console.dir(req);

    return new Promise((resolve) => {
      // NOTE: Making the /register request
      this.$http(req).then(
        (data) => {
          registerStatus = data.data.status;

          if (registerStatus === "OK") {
            console.log("API SIGN UP:", success, registerStatus, errorMessage, user);
            return resolve({
              success,
              registerStatus,
              errorMessage,
              user,
            });
          } else {
            errorMessage = data.data.message;
            success = false;

            if (errorMessage.indexOf("Duplicate entry") > -1) {
              errorMessage = "This email has already been registered in our system. Please try another or contact support.";
            }

            console.error("API SIGN UP:", success, registerStatus, errorMessage, user);
            return resolve({
              success,
              registerStatus,
              errorMessage,
              user,
            });
          }
        },
        (error) => {
          if (error.data && error.data.message) {
            success = false;
            registerStatus = error.status;
            errorMessage = error.data.message;
          } else {
            success = false;
            registerStatus = "500";
            errorMessage = "Application Error";
          }

          console.error("API SIGN UP:", success, registerStatus, errorMessage, user);
          return resolve({
            success,
            registerStatus,
            errorMessage,
            user,
          });
        }
      );
    });
  }
}

SignupRegister.$inject = ["env", "auth", "$timeout", "$rootScope", "tracking", "signup.tracking", "signup.formatting", "$http"];

export default SignupRegister;



// WEBPACK FOOTER //
// ./client/app/scenes/signup/services/register.js